import React, { createContext, useContext } from 'react';

import useStoreLocator, { IUseStoreLocator, StoreLocatorTabs } from './use-store-locator';

export const StoreLocatorContext = createContext<IUseStoreLocator>({} as IUseStoreLocator);

export { StoreLocatorTabs };

export const useStoreLocatorContext = () => useContext(StoreLocatorContext);

export const StoreLocatorProvider: React.FC = ({ children }) => {
  const {
    ErrorDialog,
    Dialog,
    activeStoreId,
    hasPanned,
    map,
    onClickSearch,
    permission,
    redirectUrl,
    searchingNearby,
    searchingRecent,
    searchingFavs,
    setActiveStoreId,
    nearbyStoreCardRefs,
    nearbyStores,
    favStores,
    recentStores,
    zoom,
    resetLocation,
    displayMapViewTabs,
    enableStoreLocatorDeliveryTab,
    enableStoreLocatorRecentTab,
    showStoreLocatorTabs,
    showGeoAskInNearbyTabWhenEmpty,
    listViewEnabled,
    loadingUserCoordinates,
    currentTab,
    handleTabChange,
    showListView,
    toggleStoreLocatorView,
    setIsStoreInfoModalOpen,
    storeLocatorDispatch,
    currentTabHasError,
  } = useStoreLocator();

  return (
    <StoreLocatorContext.Provider
      value={{
        ErrorDialog,
        Dialog,
        activeStoreId,
        hasPanned,
        map,
        onClickSearch,
        permission,
        redirectUrl,
        searchingNearby,
        searchingRecent,
        searchingFavs,
        setActiveStoreId,
        nearbyStoreCardRefs,
        nearbyStores,
        favStores,
        recentStores,
        zoom,
        resetLocation,
        displayMapViewTabs,
        enableStoreLocatorDeliveryTab,
        enableStoreLocatorRecentTab,
        showStoreLocatorTabs,
        showGeoAskInNearbyTabWhenEmpty,
        listViewEnabled,
        loadingUserCoordinates,
        showListView,
        toggleStoreLocatorView,
        currentTab,
        handleTabChange,
        setIsStoreInfoModalOpen,
        storeLocatorDispatch,
        currentTabHasError,
      }}
    >
      {children}
    </StoreLocatorContext.Provider>
  );
};
